import React, { createContext, useState, useContext, useEffect } from 'react';

const SelectedUserIdContext = createContext();

export const useSelectedUserId = () => useContext(SelectedUserIdContext);

export const SelectedUserIdProvider = ({ children }) => {
  const [selectedUserIds, setSelectedUserIds] = useState(() => {
    const savedIds = localStorage.getItem("selectedUserIds");
    return savedIds ? JSON.parse(savedIds) : [];
  });

  useEffect(() => {
    localStorage.setItem("selectedUserIds", JSON.stringify(selectedUserIds));
  }, [selectedUserIds]);

  const clearSelectedUserIds = () => {
    setSelectedUserIds([]);
    localStorage.removeItem("selectedUserIds"); 
  };

  return (
    <SelectedUserIdContext.Provider value={{ selectedUserIds, setSelectedUserIds, clearSelectedUserIds }}>
      {children}
    </SelectedUserIdContext.Provider>
  );
};